import dynamic from 'next/dynamic';
import { useParams } from 'next/navigation';

const StaticPageContainer = dynamic(
  () => import('../common/StaticPageContainer')
);
const Setair = dynamic(() => import('../setur/Setair'));
const SeturVize = dynamic(() => import('./SeturVize'));

const SeturPagesSwitch = () => {
  const params = useParams();
  const { slug = '' } = params as Record<string, string>;

  let StaticPageComponent: React.ElementType;
  switch (slug) {
    case 'setair':
      StaticPageComponent = Setair;
      break;
    case 'setur-vize':
      StaticPageComponent = SeturVize;
      break;
    default:
      StaticPageComponent = StaticPageContainer;
      break;
  }

  return <StaticPageComponent />;
};

export default SeturPagesSwitch;
